import classNames from "classnames";
import styles from "../css/IconButton.module.css";

interface IconButtonProps {
  showing: boolean;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  color?: string;
  size?: string;
  opacity?: 0;
  hideHoverAnimation?: boolean;
}

export default function IconButton(props: IconButtonProps) {
  const Icon = props.icon;

  const disableHover = props.hideHoverAnimation ?? false;

  if (!props.showing) {
    return null;
  }

  return (
    <>
      <div
        className={classNames(styles.button, {
          [styles.disableHover]: disableHover,
        })}
        onClick={disableHover === false ? props.onClick : undefined}
        style={{
          color: props.color ?? "var(--icon-default-color)",
        }}
      >
        <Icon
          className={styles.icon}
          style={{
            width: props.size ?? "24px",
            height: props.size ?? "24px",
            opacity: props.opacity ?? 1,
          }}
        />
      </div>
    </>
  );
}
